<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="position: relative;overflow: auto;height: 100%;">

    <div class="container">

        <div class="row" style="margin-top:2%;margin-bottom:2%">

            <div class="col-lg-12" style="font-size:18px">

                <div>This action will download the vault data.</div>
                
                <div>Do you want to proceed.</div>

            </div>

        </div>

    </div>

    <div class="container">

        <div class="row topRowmargins text-center" style="margin-top:8%">

            <div class="col-lg-12">
                
                <button type="button" mat-button class="btn blue-gradient btn-primary btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="background: #d71920 !important;margin-right:5%" (click)="yes()">
        
                    Yes
        
                </button>

                <button type="button" mat-button class="btn blue-gradient btn-primary btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="background: #d71920 !important" (click)="no()">
        
                    No
        
                </button>

            </div>

        </div>

    </div>

</div>